/*
  No Nasties Kids free gift + cart goals
  Settings: Shopify admin > Content > Metaobjects > "Gift campaign" and "Free shipping goal".
*/
(function () {
  if (window.__fgLoaded) return;
  window.__fgLoaded = true;

  var cfgEl = document.getElementById('fg-config');
  if (!cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { console.warn('[free-gift] bad config', e); return; }

  var SH = window.Shopify || {};
  var rate = parseFloat((SH.currency && SH.currency.rate) || '1') || 1;
  var currency = (SH.currency && SH.currency.active) || CFG.currency || 'AUD';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var isCartPage = !!CFG.isCartPage || /\/cart\/?$/.test(location.pathname);

  /* ---------- campaign + goals ---------- */
  var nowS = Date.now() / 1000;
  var campaign = (CFG.campaigns || []).filter(function (c) {
    return c.enabled && (!c.starts || c.starts <= nowS) && (!c.ends || c.ends > nowS) && c.gifts && c.gifts.length;
  })[0] || null;

  var allGiftVariantIds = {};
  (CFG.campaigns || []).forEach(function (c) {
    (c.gifts || []).forEach(function (g) { allGiftVariantIds[g.variantId] = true; });
  });

  var gifts = campaign ? campaign.gifts.filter(function (g) { return g.available; }) : [];
  var giftThreshold = campaign ? Math.round(campaign.threshold * rate * 100) : null;

  var goal = (CFG.shippingGoals || []).filter(function (g) {
    if (!g.enabled || !g.countries) return false;
    return g.countries.split(',').map(function (s) { return s.trim().toUpperCase(); }).indexOf((CFG.country || '').toUpperCase()) > -1;
  })[0] || null;
  // Goals are in AUD unless a currency is set (e.g. Canada is CAD), then it is used exactly as is.
  var shipThreshold = null;
  if (goal) {
    var goalCur = (goal.currency || '').toUpperCase();
    if (goalCur && goalCur !== 'AUD') shipThreshold = goalCur === currency.toUpperCase() ? Math.round(goal.threshold * 100) : null;
    else shipThreshold = Math.round(goal.threshold * rate * 100);
  }

  function defaultGift() {
    if (!gifts.length) return null;
    var d = gifts.filter(function (g) { return g.productId === campaign.defaultProductId; })[0];
    return d || gifts[0];
  }

  /* ---------- helpers ---------- */
  function fmt(cents) {
    var v = cents / 100;
    var whole = Math.abs(v - Math.round(v)) < 0.005;
    try {
      return new Intl.NumberFormat('en-AU', {
        style: 'currency', currency: currency,
        minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2
      }).format(v);
    } catch (e) { return '$' + v.toFixed(whole ? 0 : 2); }
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  var ss = {
    get: function (k) { try { return sessionStorage.getItem('fg_' + k); } catch (e) { return null; } },
    set: function (k, v) { try { sessionStorage.setItem('fg_' + k, v); } catch (e) {} },
    del: function (k) { try { sessionStorage.removeItem('fg_' + k); } catch (e) {} }
  };
  function testedCodes() { try { return JSON.parse(ss.get('tested') || '[]'); } catch (e) { return []; } }
  function markTested(codes) {
    var t = testedCodes();
    codes.forEach(function (c) { if (t.indexOf(c) < 0) t.push(c); });
    ss.set('tested', JSON.stringify(t));
  }

  var FG_HEADER = { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-FG': '1' };
  function getCart() {
    return fetch(root + 'cart.js', { headers: { 'X-FG': '1' }, cache: 'no-store' }).then(function (r) { return r.json(); });
  }
  function post(path, body) {
    return fetch(root + path, { method: 'POST', headers: FG_HEADER, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); });
  }
  function giftNote() {
    return 'Free on orders over ' + fmt(giftThreshold) + ' when no discount code is used';
  }
  function addGift(variantId, keepFullPrice) {
    var props = keepFullPrice
      ? { 'Note': 'Kept at full price (discount code used)', '_fg_keep': '1' }
      : { 'Free gift': giftNote(), '_fg': '1' };
    ss.set('had_gift', keepFullPrice ? '0' : '1');
    return post('cart/add.js', { items: [{ id: variantId, quantity: 1, properties: props }] });
  }
  function setLines(updates) {
    // updates: { lineKey: qty }
    return post('cart/update.js', { updates: updates });
  }
  function removeGiftLines(lines) {
    var u = {};
    lines.forEach(function (l) { u[l.key] = 0; });
    ss.set('had_gift', '0');
    return setLines(u);
  }

  function isKeepLine(i) { return i.properties && i.properties._fg_keep === '1'; }
  // A gift line is one the popup added (marked _fg). The same product bought normally is a normal line.
  function isGiftLine(i) { return !!allGiftVariantIds[i.variant_id] && !!i.properties && i.properties._fg === '1'; }
  function giftLines(cart) { return cart.items.filter(isGiftLine); }
  function hasKeep(cart) { return cart.items.some(isKeepLine); }
  function nonGiftSubtotal(cart) {
    return cart.items.reduce(function (s, i) {
      return (isGiftLine(i) || isKeepLine(i)) ? s : s + i.final_line_price;
    }, 0);
  }
  function hasMoneyCode(cart) {
    var cartLevel = (cart.cart_level_discount_applications || []).some(function (d) {
      return d.type === 'discount_code' && (d.total_allocated_amount || 0) > 0;
    });
    if (cartLevel) return true;
    return cart.items.some(function (i) {
      return (i.line_level_discount_allocations || []).some(function (a) {
        return a.amount > 0 && a.discount_application && a.discount_application.type === 'discount_code';
      });
    });
  }

  /* ---------- core rules ---------- */
  var busy = false;
  var lastCart = null;

  function evaluate(cart) {
    if (busy) return Promise.resolve();
    busy = true;
    return run(cart).catch(function (e) { console.warn('[free-gift]', e); })
      .then(function () { busy = false; });
  }

  function run(cart) {
    var gl = giftLines(cart);
    var money = hasMoneyCode(cart);
    var eligible = !!campaign && gifts.length > 0 && nonGiftSubtotal(cart) >= giftThreshold;

    lastCart = cart;
    // A fresh start (empty cart or back under the threshold) means the popup can show again.
    if (cart.item_count === 0 || !eligible) {
      ss.del('declined');
      if (cart.attributes && cart.attributes['Free gift']) post('cart/update.js', { attributes: { 'Free gift': '' } });
    }

    // 1. A money off code is applied: the gift comes out.
    if (gl.length && money) {
      return removeGiftLines(gl).then(function () { ss.set('notice', 'removed'); return refresh(); });
    }

    // 2. A code was entered but Shopify kept the gift instead. Test whether it is a money off code.
    var untested = (cart.discount_codes || []).filter(function (d) {
      return !d.applicable && testedCodes().indexOf(String(d.code).toUpperCase()) < 0;
    });
    if (gl.length && untested.length) {
      var keepVariant = gl[0].variant_id;
      return removeGiftLines(gl).then(getCart).then(function (c2) {
        if (hasMoneyCode(c2)) { ss.set('notice', 'removed'); return refresh(); }
        markTested(untested.map(function (d) { return String(d.code).toUpperCase(); }));
        return addGift(keepVariant).then(refresh);
      });
    }

    // 3. Below the threshold (or no campaign): no free gift.
    if (gl.length && !eligible) {
      return removeGiftLines(gl).then(refresh);
    }

    // 4. Only one free gift, quantity one.
    if (gl.length > 1 || (gl[0] && gl[0].quantity > 1)) {
      var u = {};
      gl.forEach(function (l, idx) { u[l.key] = idx === 0 ? 1 : 0; });
      return setLines(u).then(refresh);
    }

    // 5. Just qualified: show the chooser first. The gift is added once they pick (or close it).
    if (eligible && !gl.length && !money && !hasKeep(cart) && ss.get('declined') !== '1' && defaultGift()) {
      lastCart = cart;
      render(cart);
      if (!document.querySelector('#fg-modal.fg-modal--pending')) openChooser(cart, true);
      return Promise.resolve();
    }

    ss.set('had_gift', gl.length ? '1' : (ss.get('had_gift') === '1' ? '1' : '0'));
    lastCart = cart;
    render(cart);
    return Promise.resolve();
  }

  function refreshCartPage() {
    var items = document.getElementById('main-cart-items');
    var footer = document.getElementById('main-cart-footer');
    if (!items || !items.dataset.id) { location.reload(); return new Promise(function () {}); }
    var sid = items.dataset.id;
    var fid = (footer && footer.dataset.id) || sid;
    var ids = [sid];
    if (fid !== sid) ids.push(fid);
    return fetch(root + 'cart?sections=' + encodeURIComponent(ids.join(',')), { headers: { 'X-FG': '1' } })
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var a = new DOMParser().parseFromString(s[sid], 'text/html');
        var b = new DOMParser().parseFromString(s[fid], 'text/html');
        var newItems = a.querySelector('#main-cart-items .js-contents-items');
        var oldItems = items.querySelector('.js-contents-items');
        if (newItems && oldItems) oldItems.innerHTML = newItems.innerHTML;
        var newTotals = b.querySelector('#main-cart-footer .js-contents');
        var oldTotals = footer && footer.querySelector('.js-contents');
        if (newTotals && oldTotals) oldTotals.innerHTML = newTotals.innerHTML;
        if (!newItems || !oldItems) { location.reload(); return new Promise(function () {}); }
      })
      .then(getCart)
      .then(function (c) { lastCart = c; updateBubble(); render(c); })
      .catch(function () { location.reload(); });
  }

  function refresh() {
    if (isCartPage) return refreshCartPage();
    return getCart().then(function (c) {
      lastCart = c;
      updateBubble();
      render(c);
      if (window.publish && window.PUB_SUB_EVENTS) {
        try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'free-gift' }); } catch (e) {}
      }
    });
  }

  function updateBubble() {
    fetch(root + '?sections=cart-icon-bubble,cart-icon-bubble-sticky', { headers: { 'X-FG': '1' } })
      .then(function (r) { return r.json(); })
      .then(function (s) {
        [['cart-icon-bubble', 'cart-icon-bubble'], ['cart-icon-bubble-sticky', 'cart-icon-bubble-sticky']].forEach(function (p) {
          var el = document.getElementById(p[0]);
          if (!el || !s[p[1]]) return;
          var doc = new DOMParser().parseFromString(s[p[1]], 'text/html');
          var src = doc.querySelector('.shopify-section') || doc.body;
          if (src) el.innerHTML = src.innerHTML;
        });
      }).catch(function () {});
  }

  /* ---------- progress bar ---------- */
  function barHTML(cart) {
    if (!cart) return '';
    var money = hasMoneyCode(cart);
    var showGift = !!campaign && gifts.length > 0;
    var giftSub = nonGiftSubtotal(cart);
    var shipSub = cart.total_price;
    var gotGift = showGift && giftSub >= giftThreshold;
    var gotShip = shipThreshold != null && shipSub >= shipThreshold;

    if (!showGift && shipThreshold == null) return '';

    var msg;
    if (showGift && !gotGift && !money) {
      msg = 'You’re <strong>' + fmt(giftThreshold - giftSub) + '</strong> away from a <strong>free gift</strong> 🎁';
    } else if (shipThreshold != null && !gotShip) {
      var lead = (showGift && gotGift && !money) ? 'Free gift unlocked! ' : '';
      msg = lead + '<strong>' + fmt(shipThreshold - shipSub) + '</strong> more for <strong>free shipping</strong> 🚚';
    } else if (showGift && gotGift && !money && (shipThreshold == null || gotShip)) {
      msg = shipThreshold != null ? 'You’ve unlocked a <strong>free gift</strong> and <strong>free shipping</strong> 🎉' : 'You’ve unlocked a <strong>free gift</strong> 🎉';
    } else {
      msg = 'You’ve unlocked <strong>free shipping</strong> 🎉';
    }

    // markers
    var ICON_GIFT = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13M5 12v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-8M7.5 8a2.5 2.5 0 0 1 0-5C10 3 12 8 12 8s2-5 4.5-5a2.5 2.5 0 0 1 0 5"/></svg>';
    var ICON_TRUCK = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 6h12v10H2zM14 9h4l3 3v4h-7z"/><circle cx="6" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg>';
    var hasGiftInCart = giftLines(cart).length > 0;
    var marks = [];
    if (showGift) marks.push({ at: giftThreshold, label: 'Free Gift', icon: ICON_GIFT, done: gotGift && !money, off: money, change: hasGiftInCart && gifts.length > 1 });
    if (shipThreshold != null) marks.push({ at: shipThreshold, label: 'Free Shipping ' + fmt(shipThreshold) + '+', icon: ICON_TRUCK, done: gotShip });
    var max = Math.max.apply(null, marks.map(function (m) { return m.at; }));
    var progressValue = showGift && (shipThreshold == null) ? giftSub : shipSub;
    if (showGift && shipThreshold != null) progressValue = Math.max(Math.min(giftSub, giftThreshold) , shipSub);
    var pct = Math.max(0, Math.min(100, (progressValue / max) * 100));

    var marksHTML = marks.map(function (m) {
      var left = Math.min(100, (m.at / max) * 100);
      return '<div class="fg-mark' + (m.done ? ' is-done' : '') + (m.off ? ' is-off' : '') + '" style="left:' + left + '%">' +
        '<span class="fg-mark__dot">' + m.icon + '</span>' +
        '<span class="fg-mark__label">' + esc(m.label) +
        (m.change ? ' <button type="button" class="fg-link" data-fg-open>Change</button>' : '') + '</span></div>';
    }).join('');

    var giftRow = '';
    var gl = giftLines(cart);
    if (showGift && gl.length) {
      giftRow = '';
    } else if (showGift && gotGift && !money && ss.get('declined') === '1') {
      giftRow = '<div class="fg-bar__gift"><button type="button" class="fg-btn fg-btn--small" data-fg-choose>Choose your free gift</button></div>';
    } else if (showGift && money) {
      giftRow = '<div class="fg-bar__gift fg-bar__gift--muted">The free gift can’t be combined with discount codes.</div>';
    }

    return '<div class="fg-bar__msg">' + msg + '</div>' +
      '<div class="fg-track"><div class="fg-track__fill" style="width:' + pct + '%"></div>' + marksHTML + '</div>' + giftRow;
  }

  function mountBars() {
    if (!document.getElementById('fg-bar-site')) {
      var secs = document.querySelectorAll('.shopify-section-group-header-group');
      var host = secs.length ? secs[secs.length - 1] : null;
      var main = document.getElementById('MainContent');
      var el = document.createElement('div');
      el.id = 'fg-bar-site';
      el.className = 'fg-bar fg-bar--site';
      if (host) host.appendChild(el);
      else if (main) main.insertBefore(el, main.firstChild);
    }
    var drawerHeader = document.querySelector('cart-drawer .drawer__header');
    if (drawerHeader && !document.getElementById('fg-bar-drawer')) {
      var d = document.createElement('div');
      d.id = 'fg-bar-drawer';
      d.className = 'fg-bar';
      drawerHeader.parentNode.insertBefore(d, drawerHeader.nextSibling);
    }
  }

  function render(cart) {
    mountBars();
    var html = barHTML(cart);
    ['fg-bar-site', 'fg-bar-drawer'].forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      var h = (id === 'fg-bar-drawer' && cart.item_count === 0) ? '' : html;
      el.innerHTML = h; el.hidden = !h;
    });
    renderCodeBox(cart);
  }

  // Small toast with progress on pages without a cart bar
  var toastTimer;
  function toast(cart) {
    if (isCartPage) return;
    var html = barHTML(cart);
    if (!html) return;
    var t = document.getElementById('fg-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'fg-toast';
      t.className = 'fg-toast';
      document.body.appendChild(t);
    }
    t.innerHTML = '<button type="button" class="fg-toast__close" aria-label="Close">×</button><div class="fg-bar">' + html + '</div>';
    t.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-on'); }, 7000);
  }

  /* ---------- discount code box (cart page) ---------- */
  function renderCodeBox(cart) {
    if (!isCartPage || !cart || cart.item_count === 0) return;
    var ctas = document.querySelector('#main-cart-footer .cart__ctas');
    if (!ctas) return;
    var box = document.getElementById('fg-code');
    if (!box) {
      box = document.createElement('div');
      box.id = 'fg-code';
      box.className = 'fg-code';
      ctas.parentNode.insertBefore(box, ctas);
    }
    var codes = cart.discount_codes || [];
    var applied = codes.map(function (d) {
      return '<span class="fg-chip' + (d.applicable ? '' : ' is-na') + '">' + esc(d.code) +
        (d.applicable ? '' : ' <em>(not applied)</em>') +
        ' <button type="button" data-fg-remove-code="' + esc(d.code) + '" aria-label="Remove code">×</button></span>';
    }).join('');
    box.innerHTML =
      '<label class="fg-code__label" for="fg-code-input">Have a discount code?</label>' +
      '<div class="fg-code__row"><input id="fg-code-input" type="text" autocomplete="off" placeholder="Enter code">' +
      '<button type="button" class="fg-btn" data-fg-apply>Apply</button></div>' +
      '<div class="fg-code__msg" role="status"></div>' +
      (applied ? '<div class="fg-code__chips">' + applied + '</div>' : '');
  }

  function applyCode(code) {
    code = String(code || '').trim();
    var msgEl = document.querySelector('#fg-code .fg-code__msg');
    if (!code) return;
    if (msgEl) msgEl.textContent = 'Applying…';
    busy = true;
    getCart().then(function (cart) {
      var existing = (cart.discount_codes || []).map(function (d) { return d.code; })
        .filter(function (c) { return c.toUpperCase() !== code.toUpperCase(); });
      existing.push(code);
      return post('cart/update.js', { discount: existing.join(',') });
    }).then(getCart).then(function (cart) {
      busy = false;
      var mine = (cart.discount_codes || []).filter(function (d) { return d.code.toUpperCase() === code.toUpperCase(); })[0];
      if (!mine) {
        if (msgEl) msgEl.textContent = 'Sorry, that code isn’t valid.';
        return;
      }
      if (!mine.applicable && !giftLines(cart).length) {
        if (msgEl) msgEl.textContent = 'Sorry, that code can’t be used on this cart.';
        return post('cart/update.js', {
          discount: (cart.discount_codes || []).filter(function (d) { return d !== mine; }).map(function (d) { return d.code; }).join(',')
        }).then(function () { setTimeout(function () { location.reload(); }, 1400); });
      }
      return evaluate(cart).then(function () { location.reload(); });
    }).catch(function () {
      busy = false;
      if (msgEl) msgEl.textContent = 'Something went wrong, please try again.';
    });
  }

  function removeCode(code) {
    busy = true;
    getCart().then(function (cart) {
      var rest = (cart.discount_codes || []).map(function (d) { return d.code; })
        .filter(function (c) { return c.toUpperCase() !== String(code).toUpperCase(); });
      ss.del('declined');
      return post('cart/update.js', { discount: rest.join(',') });
    }).then(function () { busy = false; location.reload(); });
  }

  /* ---------- popups ---------- */
  function modal(inner, cls) {
    closeModal();
    var m = document.createElement('div');
    m.className = 'fg-modal ' + (cls || '');
    m.id = 'fg-modal';
    m.setAttribute('role', 'dialog');
    m.setAttribute('aria-modal', 'true');
    m.innerHTML = '<div class="fg-modal__overlay" data-fg-close></div><div class="fg-modal__box">' +
      '<button type="button" class="fg-modal__x" data-fg-close aria-label="Close">×</button>' + inner + '</div>';
    document.body.appendChild(m);
    document.body.classList.add('fg-lock');
    setTimeout(function () { m.classList.add('is-on'); }, 10);
  }
  function closeModal() {
    var m = document.getElementById('fg-modal');
    if (m) m.remove();
    document.body.classList.remove('fg-lock');
  }

  function openChooser(cart, pending) {
    if (!gifts.length) return;
    var gl = cart ? giftLines(cart) : [];
    var current = gl.length ? gl[0].variant_id : (defaultGift() || {}).variantId;
    var cards = gifts.map(function (g) {
      return '<label class="fg-card">' +
        '<input type="radio" name="fg-gift" value="' + g.variantId + '"' + (g.variantId === current ? ' checked' : '') + '>' +
        '<span class="fg-card__img">' + (g.image ? '<img src="' + esc(g.image) + '" alt="" loading="lazy">' : '') + '</span>' +
        '<span class="fg-card__title">' + esc(g.title) + '</span>' +
        '<span class="fg-card__price"><s>' + fmt(g.price) + '</s> <strong>FREE</strong></span>' +
        '<span class="fg-card__tick" aria-hidden="true">✓</span></label>';
    }).join('');
    modal(
      '<p class="fg-modal__eyebrow">🎉 You’ve unlocked a free gift!</p>' +
      '<h2 class="fg-modal__title">Choose your free gift</h2>' +
      '<div class="fg-cards">' + cards + '</div>' +
      '<button type="button" class="fg-btn fg-btn--full" data-fg-confirm>Add my gift</button>' +
      '<p class="fg-modal__small">Free gifts can’t be combined with discount codes.</p>' +
      '<button type="button" class="fg-nothanks" data-fg-decline>No thanks, I don’t need a free gift</button>',
      'fg-modal--chooser' + (pending ? ' fg-modal--pending' : '')
    );
  }

  function confirmChoice() {
    var sel = document.querySelector('#fg-modal input[name="fg-gift"]:checked');
    if (!sel) { closeModal(); return; }
    var vid = parseInt(sel.value, 10);
    var btn = document.querySelector('#fg-modal [data-fg-confirm]');
    if (btn) { if (btn.disabled) return; btn.disabled = true; btn.textContent = 'Adding your gift…'; }
    busy = true;
    getCart().then(function (cart) {
      var gl = giftLines(cart);
      if (gl.length && gl[0].variant_id === vid && gl.length === 1) return null;
      var p = gl.length ? removeGiftLines(gl) : Promise.resolve();
      return p.then(function () {
        ss.del('declined');
        var clear = (cart.attributes && cart.attributes['Free gift']) ? post('cart/update.js', { attributes: { 'Free gift': '' } }) : Promise.resolve();
        return clear.then(function () { return addGift(vid); });
      });
    }).then(function () {
      busy = false;
      closeModal();
      return refresh();
    }).catch(function () { busy = false; closeModal(); });
  }

  function openRemovedNotice() {
    var giftVariant = ss.get('last_gift');
    modal(
      '<p class="fg-modal__eyebrow">🎉 Your discount code has been applied</p>' +
      '<h2 class="fg-modal__title">A quick heads up about your free gift</h2>' +
      '<p class="fg-modal__text">Our free gift can’t be combined with discount codes, so we’ve taken it out of your cart for you. ' +
      'Prefer the free gift instead? Simply remove your code and you can choose your gift again.</p>' +
      '<div class="fg-modal__actions">' +
      '<button type="button" class="fg-btn" data-fg-close>Got it</button>' +
      (giftVariant ? '<button type="button" class="fg-btn fg-btn--ghost" data-fg-keep="' + esc(giftVariant) + '">Keep the gift at full price</button>' : '') +
      '</div>'
    );
  }

  // Customer doesn't want a gift: take it out and leave a note on the order for the team.
  function declineGift() {
    var link = document.querySelector('#fg-modal [data-fg-decline]');
    if (link) { if (link.disabled) return; link.disabled = true; }
    busy = true;
    ss.set('declined', '1');
    getCart().then(function (cart) {
      var gl = giftLines(cart);
      var p = gl.length ? removeGiftLines(gl) : Promise.resolve();
      return p.then(function () { return post('cart/update.js', { attributes: { 'Free gift': 'Customer opted out of free gift' } }); });
    }).then(function () {
      busy = false;
      closeModal();
      return refresh();
    }).catch(function () { busy = false; closeModal(); });
  }

  function dismiss() {
    if (document.querySelector('#fg-modal.fg-modal--pending')) confirmChoice();
    else closeModal();
  }

  /* ---------- events ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-fg-close]')) { e.preventDefault(); dismiss(); return; }
    if (t.closest('[data-fg-open]')) { e.preventDefault(); getCart().then(openChooser); return; }
    if (t.closest('[data-fg-choose]')) { e.preventDefault(); ss.del('declined'); getCart().then(openChooser); return; }
    if (t.closest('[data-fg-confirm]')) { e.preventDefault(); confirmChoice(); return; }
    if (t.closest('[data-fg-decline]')) { e.preventDefault(); declineGift(); return; }
    if (t.closest('[data-fg-apply]')) {
      e.preventDefault();
      var inp = document.getElementById('fg-code-input');
      applyCode(inp && inp.value);
      return;
    }
    var rc = t.closest('[data-fg-remove-code]');
    if (rc) { e.preventDefault(); removeCode(rc.getAttribute('data-fg-remove-code')); return; }
    var keep = t.closest('[data-fg-keep]');
    if (keep) {
      e.preventDefault();
      busy = true;
      addGift(parseInt(keep.getAttribute('data-fg-keep'), 10), true).then(function () {
        busy = false; ss.del('last_gift'); closeModal(); return refresh();
      });
      return;
    }
    if (t.closest('.fg-toast__close')) { var tt = document.getElementById('fg-toast'); if (tt) tt.classList.remove('is-on'); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') dismiss();
    if (e.key === 'Enter' && e.target && e.target.id === 'fg-code-input') { e.preventDefault(); applyCode(e.target.value); }
  });

  // Remember which gift was in the cart so "keep at full price" can restore it.
  var _removeGiftLines = removeGiftLines;
  removeGiftLines = function (lines) {
    if (lines[0]) ss.set('last_gift', String(lines[0].variant_id));
    return _removeGiftLines(lines);
  };

  // If the customer removes the free gift themselves, don't add it back. They can choose again from the bar.
  function noteManualGiftRemoval(url, body) {
    try {
      var data = {};
      if (typeof body === 'string') { try { data = JSON.parse(body); } catch (e) { data = Object.fromEntries(new URLSearchParams(body)); } }
      else if (body && typeof body.get === 'function') { body.forEach(function (v, k) { data[k] = v; }); }
      var items = lastCart.items;
      var hit = function (item) { return item && isGiftLine(item); };
      if (/\/cart\/change/.test(url) && String(data.quantity) === '0') {
        var target = null;
        if (data.line) target = items[parseInt(data.line, 10) - 1];
        else if (data.id) target = items.filter(function (i) { return String(i.key) === String(data.id) || String(i.variant_id) === String(data.id); })[0];
        if (hit(target)) ss.set('declined', '1');
      }
      if (/\/cart\/update/.test(url) && data.updates) {
        var u = data.updates;
        items.forEach(function (i, idx) {
          var q = Array.isArray(u) ? u[idx] : (u[i.key] != null ? u[i.key] : u[i.variant_id]);
          if (q != null && String(q) === '0' && hit(i)) ss.set('declined', '1');
        });
      }
    } catch (e) {}
  }

  // Watch every cart change made by the theme or other apps.
  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var headers = (init && init.headers) || {};
    var mine = headers['X-FG'] || (headers.get && headers.get('X-FG'));
    // Removing the gift while still over the threshold simply brings the chooser back.
    var p = origFetch.apply(this, arguments);
    if (!mine && /\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function () {
        setTimeout(function () {
          getCart().then(function (c) {
            return evaluate(c).then(function () {
              if (ss.get('open_popup') === '1') { ss.del('open_popup'); getCart().then(openChooser); }
              else if (ss.get('notice') === 'removed') { ss.del('notice'); openRemovedNotice(); }
            });
          });
        }, 150);
      }).catch(function () {});
    }
    return p;
  };

  // Re-mount bars if the theme re-renders the cart drawer.
  var mo = new MutationObserver(function () {
    if (lastCart && document.querySelector('cart-drawer .drawer__header') && !document.getElementById('fg-bar-drawer')) render(lastCart);
  });

  function init() {
    if (!campaign && !goal) return;
    mo.observe(document.body, { childList: true, subtree: true });
    getCart().then(function (cart) {
      return evaluate(cart).then(function () {
        if (ss.get('open_popup') === '1') { ss.del('open_popup'); getCart().then(openChooser); }
        else if (ss.get('notice') === 'removed') { ss.del('notice'); openRemovedNotice(); }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
